var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.5c-.281 0-.5.25-.5.5v12c0 .281.219.5.5.5h2.5v-2A1.5 1.5 0 0 1 6 11c.813 0 1.5.688 1.5 1.5v2H10c.25 0 .5-.219.5-.5V2c0-.25-.25-.5-.5-.5H2zM0 2C0 .906.875 0 2 0h8c1.094 0 2 .906 2 2v12c0 1.125-.906 2-2 2H2c-1.125 0-2-.875-2-2V2zm2.75 1.25c0-.25.219-.5.5-.5h1.5c.25 0 .5.25.5.5v1.5c0 .281-.25.5-.5.5h-1.5a.494.494 0 0 1-.5-.5v-1.5zm4.5-.5h1.5c.25 0 .5.25.5.5v1.5c0 .281-.25.5-.5.5h-1.5a.494.494 0 0 1-.5-.5v-1.5c0-.25.219-.5.5-.5zm-4.5 4.5c0-.25.219-.5.5-.5h1.5c.25 0 .5.25.5.5v1.5c0 .281-.25.5-.5.5h-1.5a.494.494 0 0 1-.5-.5v-1.5zm4.5-.5h1.5c.25 0 .5.25.5.5v1.5c0 .281-.25.5-.5.5h-1.5a.494.494 0 0 1-.5-.5v-1.5c0-.25.219-.5.5-.5z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/AccountIcon.5e1f0d952730e603d18d99d37b27810e.svg";
export { ForwardRef as ReactComponent };